'use client';

import React from 'react';
import { IoIosArrowDown, IoIosArrowUp } from 'react-icons/io';
import { useTekstClient } from 'hooks/useTekstClient';

export default function FilterGroup({
    styles,
    filter,
    isExpanded,
    isSubExpanded,
    maxVisibleSubfilters,
    getSelectedForSlug,
    onToggleFilter,
    onToggleSubfilter,
    onToggleSubfiltersExpanded,
}) {
    const { tekst } = useTekstClient();
    const allSubs = filter.subfilters ?? [];
    const hasOverflow = allSubs.length > maxVisibleSubfilters;
    const visibleSubs = hasOverflow && !isSubExpanded
        ? allSubs.slice(0, maxVisibleSubfilters)
        : allSubs;
    const hiddenCount = allSubs.length - maxVisibleSubfilters;
    const slug = filter.slug ?? 'filter_' + filter.id;

    return (
        <div className={styles.filterGroup}>
            <button
                type="button"
                className={styles.filterHeader}
                onClick={() => onToggleFilter(filter.id)}
                aria-expanded={isExpanded}
            >
                {isExpanded ? <IoIosArrowUp /> : <IoIosArrowDown />}
                <span>{filter.naam}</span>
            </button>
            {isExpanded && (
                <div className={styles.subfilters}>
                    {visibleSubs.map((sub) => {
                        const isSelected = getSelectedForSlug(slug).has(sub.id);
                        const isUnavailable = !isSelected && Number(sub?.count ?? 0) <= 0;
                        return (
                            <button
                                key={sub.id}
                                type="button"
                                className={`btn-nostyling ${styles.subfilterLabel} ${isSelected ? styles.subfilterLabelSelected : ''} ${isUnavailable ? styles.subfilterLabelDisabled : ''}`}
                                onClick={() => onToggleSubfilter(slug, sub.id)}
                                disabled={isUnavailable}
                                aria-disabled={isUnavailable}
                            >
                                <span>{sub.naam}</span>
                            </button>
                        );
                    })}
                    {hasOverflow && (
                        <button
                            type="button"
                            className={`btn-nostyling ${styles.showMoreBtn}`}
                            onClick={() => onToggleSubfiltersExpanded(filter.id)}
                        >
                            {isSubExpanded ? (
                                <>
                                    <span>{tekst('mkgeu:mkgaddons:filters:showless')}</span>
                                    <IoIosArrowUp />
                                </>
                            ) : (
                                <>
                                    <span>{tekst('mkgeu:mkgaddons:filters:showmorecount', {
                                        count: hiddenCount,
                                        type: tekst('mkgeu:mkgaddons:filters:label:filter', null, hiddenCount),
                                    })}</span>
                                    <IoIosArrowDown />
                                </>
                            )}
                        </button>
                    )}
                </div>
            )}
        </div>
    );
}
